import React from 'react';
import PropTypes from 'prop-types';
import Async from '../../../../core/layout/Async';
import Row from '../../../../core/layout/Row';
import Column from '../../../../core/layout/Column';
import PartnerAccessFrequencySummaryContainer from './partner/PartnerAccessFrequencySummaryContainer';
import PartnerLicensePackageUsageSummaryContainer from './partner/PartnerLicensePackageUsageSummaryContainer';
import PartnerStudentVariationSummaryContainer from './partner/PartnerStudentVariationSummaryContainer';
import StudentAccessFrequencySummaryContainer from './student/StudentAccessFrequencySummaryContainer';
import StudentEngagementSummaryContainer from './student/StudentEngagementSummaryContainer';
import StudentChurnSummaryContainer from './student/StudentChurnSummaryContainer';
import StudentStudyQualitySummaryContainer from './student/StudentStudyQualitySummaryContainer';

const CustomerSuccessSummary = (props) => (
  <Async fetching={props.isLoading}>
    <Row>
      <Column size="5">
        <span
          style={{
            display: 'block',
            borderBottom: '1px solid #d7d7d7',
            fontWeight: 'bold',
            textAlign: 'center',
            paddingBottom: 8,
          }}
        >
          Partner
        </span>
        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <PartnerAccessFrequencySummaryContainer type={props.type} typeId={props.typeId} />
          <PartnerLicensePackageUsageSummaryContainer type={props.type} typeId={props.typeId} />
          <PartnerStudentVariationSummaryContainer type={props.type} typeId={props.typeId} />
        </div>
      </Column>
      <Column size="6" offset="2">
        <span
          style={{
            display: 'block',
            borderBottom: '1px solid #d7d7d7',
            fontWeight: 'bold',
            textAlign: 'center',
            paddingBottom: 8,
          }}
        >
          Student
        </span>
        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <StudentAccessFrequencySummaryContainer type={props.type} typeId={props.typeId} />
          <StudentEngagementSummaryContainer type={props.type} typeId={props.typeId} />
          <StudentChurnSummaryContainer type={props.type} typeId={props.typeId} />
          <StudentStudyQualitySummaryContainer type={props.type} typeId={props.typeId} />
        </div>
      </Column>
    </Row>
  </Async>
);

CustomerSuccessSummary.propTypes = {
  isLoading: PropTypes.bool,
  type: PropTypes.oneOf(['segment', 'distributor']).isRequired,
  typeId: PropTypes.string.isRequired,
};

CustomerSuccessSummary.defaultProps = {
  isLoading: false,
};

export default CustomerSuccessSummary;
